import { useState } from 'react';
import { MoveFocusInside } from 'react-focus-on';
import { useModalContentManager } from '@provider/notifier';
import { EditInput, Button } from '@ui/kit';
import { FloppyIcon } from '@ui/kit/icons';
import { modal, heading, text, input, legalText, buttonsWrapper } from './_shared.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const makeLeaveNewRevisionModalConfig = options => ({
  theme: "dialog",
  className: modal,
  requiresAction: options?.requiresInteraction,
  content: /*#__PURE__*/jsx(LeaveRevisionModal, {})
});
function LeaveRevisionModal() {
  const manager = useModalContentManager();
  const [title, setTitle] = useState("");
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsx("h1", {
      className: heading,
      children: "Vil du gemme din version af forl\xF8bet?"
    }), /*#__PURE__*/jsx("p", {
      className: text,
      children: "Giv din nye version en titel og gem den til fremtidig brug."
    }), /*#__PURE__*/jsx(MoveFocusInside, {
      children: /*#__PURE__*/jsx(EditInput, {
        className: input,
        mode: "always-visible",
        type: "text",
        "aria-label": "Titel p\xE5 din version",
        placeholder: "Angiv titel her*",
        value: title,
        onChange: setTitle
      })
    }), /*#__PURE__*/jsx("p", {
      className: legalText,
      children: "*V\xE6r opm\xE6rksom p\xE5 at navngivningen er synlig for alle med linket. Der m\xE5 derfor ikke v\xE6re f\xF8lsomme eller fortrolige oplysninger i navngivningen."
    }), /*#__PURE__*/jsxs("div", {
      className: buttonsWrapper,
      children: [/*#__PURE__*/jsx(Button, {
        theme: "secondary",
        onClick: () => manager.onDismiss({
          intent: "do-not-save"
        }),
        children: "Gem ikke"
      }), /*#__PURE__*/jsx(Button, {
        theme: "primary",
        icon: /*#__PURE__*/jsx(FloppyIcon, {}),
        onClick: () => manager.onDismiss({
          intent: "save",
          title
        }),
        tooltip: {
          disabled: !!title,
          body: "Du skal angive en titel før du kan gemme din version",
          ariaType: "description"
        },
        disabled: !title,
        children: "Gem og luk"
      })]
    })]
  });
}

export { makeLeaveNewRevisionModalConfig };
//# sourceMappingURL=leave.new.js.map
